import { solutionsServiceModule } from '../../../../services/solutions-service/solutions-service';
import { firebaseServiceModule } from '../../../../../../shared/app/services/firebase/firebase';
import { appAlertComponentModule } from '../../../../../../shared/app/components/app-alert/app-alert';
import { challengeProcessHelperModule } from '../challenge-process-helper';

export const quizChallengeProcessServiceModule = angular
  .module(
    'Q.routes.assessments.challenges.code-challenge.quiz-challenge-process-service',
    [
      solutionsServiceModule,
      firebaseServiceModule,
      appAlertComponentModule,
      challengeProcessHelperModule,
    ],
  )

  .factory(
    'quizChallengeProcessService',
    function (
      solutionsService,
      Solution,
      $q,
      firebase,
      appAlert,
      challengeProcessHelper,
    ) {
      return {
        create,
      };

      //// functions:

      function create(challenge, assessmentResultProcess) {
        const assessmentResult = assessmentResultProcess.assessmentResult;
        const process = {
          challenge,
          beginChallenge,
          incomplete,
          cleanupAfterSave,
        };

        return challengeProcessHelper(process, assessmentResultProcess);

        //// functions:

        function beginChallenge() {
          return assessmentResultProcess
            .startAssessmentResult()
            .then(() => solutionsService.create(challenge, assessmentResult))
            .then(process.initSolution)
            .catch(appAlert.modelError);
        }

        function incomplete() {
          return process.solution && !process.solution.allAnswered();
        }

        function cleanupAfterSave(force) {
          // due to the way answers are stored, we have to clean them up, because the IDs get changed on every save
          if (
            process.solution &&
            process.solution.answers &&
            process.originalSolution.answers
          ) {
            const keys = ['id', 'questionRevisionNumber', 'score'];
            if (force) {
              keys.push('values');
            }
            process.solution.answers.forEach((ans) => {
              let oAns = process.originalSolution.answers.find(
                (a) => a.questionId === ans.questionId,
              );
              if (oAns) {
                keys.forEach((key) => {
                  ans[key] = oAns[key];
                });
              }
            });
          }
        }
      }
    },
  );
